import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import { getInclusionIcon } from 'lib/offer/getInclusionIcon'
import getInclusionMinStayText from 'lib/offer/getInclusionMinStayText'
import React from 'react'

interface Props {
  inclusion: App.TileInclusion;
}

function OfferPageIntroInclusionItem(props: Props) {
  const { inclusion } = props

  const InclusionIcon = getInclusionIcon(inclusion.icon ?? '')
  const inclusionMinStayText = getInclusionMinStayText(inclusion)

  return <BodyTextBlock key={inclusion.text} variant="large" startIcon={<InclusionIcon />}>
    {inclusion.text} {inclusionMinStayText}
  </BodyTextBlock>
}

export default OfferPageIntroInclusionItem
